import * as Sentry from "@sentry/react";

type PromoTags = {
  promoId?: string | null;
  promoType?: string | null;
  promoCategory?: string | null;
};

export const setRouteTag = (pathname: string) => {
  Sentry.setTag("widget_route", pathname);
};

export const setPromoTags = ({ promoId, promoType, promoCategory }: PromoTags) => {
  if (promoId) Sentry.setTag("promo_id", promoId);
  if (promoType) Sentry.setTag("promo_type", promoType);
  if (promoCategory) Sentry.setTag("promo_category", promoCategory);
};
